import { render, staticRenderFns } from "./addEmBase.vue?vue&type=template&id=80712f56&scoped=true&"
import script from "./addEmBase.vue?vue&type=script&lang=js&"
export * from "./addEmBase.vue?vue&type=script&lang=js&"
import style0 from "./addEmBase.vue?vue&type=style&index=0&id=80712f56&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80712f56",
  null
  
)

export default component.exports